import React from 'react';
import Chart, { Props as ChartProps } from 'react-apexcharts';
import { merge } from 'lodash';

const PieChart = ({ options, ...props }: ChartProps): React.ReactElement => {
  return (
    <Chart
      type="pie"
      options={merge(
        {
          chart: {
            animations: { enabled: props.width === '100%' },
            fontFamily: 'futura-pt'
          },
          stroke: { lineCap: 'butt' },
          legend: { show: false },
          tooltip: {
            enabled: true,
            marker: { show: false },
            theme: 'dark',
            x: { show: false },
            fillSeriesColor: false
          }
        },
        options
      )}
      {...props}
    />
  );
};

export default PieChart;
